import { getItemByField } from "../../../../web-graphics";
import { OnlinePlotProvider } from "./online-plot-provider";

export class OnlineRhythmPlotProvider extends OnlinePlotProvider {
  constructor(id, type, webglPlot) {
    super(id, type, webglPlot);

    this.signalIdMap = new Map();
    this.rhythmChannelInfo = OnlineRhythmPlotProvider._getFirstRhythmChannel(this.webglPlot);
    if (this.rhythmChannelInfo !== undefined) {
      this.sourceChannelInfo = this.rhythmChannelInfo.conversionSettings.sourceChannel;
    }
    OnlineRhythmPlotProvider._updateChannelSource(this.viewSettings, this.sourceChannelInfo);
  }

  init() {
    super.init();
    OnlineRhythmPlotProvider._changeSourceSignals(
      [this.viewSettings.signalBox.current.id],
      this.rhythmChannelInfo,
      this.sourceChannelInfo,
      this.webglPlot,
      this.signalIdMap,
      this.viewSettings
    );
  }

  addSignalPoints(sourceId, channelId, signalId, data) {
    if (this.sourceChannelInfo.id != channelId) {
      return;
    }
    let plotSignal = this.signalIdMap.get(signalId);
    if (plotSignal !== undefined) {
      this.hasAddedPoints = true;
      this.webglPlot.addPoints(sourceId, this.rhythmChannelInfo.id, plotSignal, data);
    }
  }

  addPoints(sourceId, channelId, messageSignals) {
    for (let signalIndex = 0; signalIndex < messageSignals.length; signalIndex++) {
      let plotSignal = this.signalIdMap.get(signalIndex);
      if (plotSignal !== undefined) {
        this.hasAddedPoints = true;
        this.webglPlot.addPoints(sourceId, channelId, plotSignal, messageSignals[signalIndex].data);
      }
    }
  }

  updateChannelSource() {
    OnlineRhythmPlotProvider._updateChannelSource(this.viewSettings, this.sourceChannelInfo);
    this.onViewSettingsChanged?.(this.id);
  }

  updateSourceConfiguration(configName) {
    this.sourceChannelInfo.currConfiguration = configName;
  }

  changeSourceSignals(newSignalsIdList) {
    OnlineRhythmPlotProvider._changeSourceSignals(
      newSignalsIdList,
      this.rhythmChannelInfo,
      this.sourceChannelInfo,
      this.webglPlot,
      this.signalIdMap,
      this.viewSettings
    );
    newSignalsIdList.forEach(signalId => {
      let signalBoxValue = getItemByField("id", signalId, this.viewSettings.signalBox.values);
      this.viewSettings.signalBox.current = signalBoxValue;
    });
    this.onViewSettingsChanged?.(this.id);
  }

  static _changeSourceSignals(newSignalsIdList, rhythmChannelInfo, sourceChannelInfo, webglPlot, signalIdMap, viewSettings) {
    if (rhythmChannelInfo === undefined) {
      return;
    }
    let sourceConfiguration = getItemByField("name", sourceChannelInfo.currConfiguration, sourceChannelInfo.configurations);
    let dataSource = getItemByField("id", rhythmChannelInfo.id_dataSource, webglPlot.settings.dataSources);
    let channelSettings = getItemByField("id", rhythmChannelInfo.id, dataSource.channels);
    let configurationSettings = getItemByField("name", rhythmChannelInfo.currConfiguration, channelSettings.configurations);
    let newConfigSettings = configurationSettings.copy();
    let signalLabels = getItemByField("name", "signalLabels", newConfigSettings.plotContent.leftCentral)?.settings?.settings;
    signalIdMap.clear();
    for (let signalIndex = 0; signalIndex < newConfigSettings.signals.length; signalIndex++) {
      let signalSettings = newConfigSettings.signals[signalIndex];
      let sourceSignalSettings = getItemByField("id", newSignalsIdList[signalIndex], sourceConfiguration.signals);
      signalIdMap.set(newSignalsIdList[signalIndex], signalSettings.id);
      signalSettings.title = sourceSignalSettings.title;
      let signalLabel = getItemByField("id_signal", signalSettings.id, signalLabels);
      if (signalLabel !== undefined) {
        signalLabel.text = sourceSignalSettings.title;
      }
    }
    webglPlot.updateCurrConfiguration(rhythmChannelInfo.id_dataSource, rhythmChannelInfo.id, newConfigSettings);
    if (viewSettings.linkedChannel !== undefined) {
      webglPlot.onSignalLabelClicked(viewSettings.linkedChannel.id_dataSource, viewSettings.linkedChannel.id);
    }
  }

  static _getFirstRhythmChannel(webglPlot) {
    let dataSources = webglPlot.settings.dataSources;
    for (let sourceIndex = 0; sourceIndex < dataSources.length; sourceIndex++) {
      let channels = dataSources[sourceIndex].channels;
      for (let channelIndex = 0; channelIndex < channels.length; channelIndex++) {
        if (channels[channelIndex].conversionSettings?.type == "rhythm") {
          return channels[channelIndex];
        }
      }
    }
    return undefined;
  }

  static _updateChannelSource(viewSettings, sourceChannelInfo) {
    viewSettings.signalBox = {
      current: null,
      values: []
    };
    let currSourceConfiguration = getItemByField("name", sourceChannelInfo.currConfiguration, sourceChannelInfo.configurations);
    currSourceConfiguration.signals.forEach(signalInfo => {
      viewSettings.signalBox.values.push({
        title: signalInfo.title,
        id: signalInfo.id
      });
    });
    if (viewSettings.signalBox.values.length > 0) {
      let currentSignal = viewSettings.signalBox.values[0];
      viewSettings.signalBox.current = {
        title: currentSignal.title,
        id: currentSignal.id
      };
    }
  }
}
